import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://192.168.196.4:8085';



export const createEmployer = async (userReferenceId: string, companyName: string, companyNIP: string, description: string, isNaturalPerson: boolean) => {
    console.log(userReferenceId, companyName, companyNIP, description, isNaturalPerson);
    try {
        const response = await axios(`${BASE_URL}/employer/register`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            data: {
                userReferenceId: userReferenceId,
                companyName: companyName,
                nip: companyNIP,
                description: description,
                isNaturalPerson: isNaturalPerson,
            },
            withCredentials: true

        });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            throw new Error(error.response?.data?.message || error.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
}